import React, { Component } from "react";
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment,
  Dimmer,
  Loader
} from "semantic-ui-react";
import { Link, Redirect } from "react-router-dom";

import fire from "../../config/config";

class LoginForm extends Component {
  state = {
    email: "",
    password: "",
    errMsg: null,
    signedIn: false,
    loading: false,
    forgotPass: false
  };

  componentDidMount() {
    fire.auth().onAuthStateChanged(user => {
      //if user is Already signed in redirect him to his dashboard
      if (user) {
        this.setState({ signedIn: true });
      }
    });
  }

  login(e) {
    const { email, password } = this.state;

    this.setState({ loading: true });

    e.preventDefault();
    //console.log("e:", e);

    fire
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState({ signedIn: true });
      })
      .catch(err => {
        //console.log(err);
        this.setState({
          errMsg: "Password incorrect or email incorrect",
          loading: false
        });
      });
  }

  passReset(){
    //
    this.setState({loading: true})
    const {email} = this.state
    if (email.replace(/\s/g, "")!==''){
      fire.auth().sendPasswordResetEmail(email)
        .then(()=>{
          this.setState({errMsg: 'Email Sent', loading: false})
        }, (err)=> {
          this.setState({errMsg: err.message, loading: false})
        })
    }
    else{
      this.setState({errMsg: 'Please enter your email', loading: false})
    }
  }

  render() {
    const { errMsg, signedIn, loading, forgotPass } = this.state;

    if (signedIn) {
      return <Redirect to="/dashboard" />;
    }

    if(forgotPass){
      return (
        <div className="LoginForm">
          {/*
              Heads up! The styles below are necessary for the correct render of this example.
              You can do same with CSS, the main idea is that all the elements up to the `Grid`
              below must have a height of 100%.
            */}
          <style>{`
              body > div,
              body > div > div,
              body > div > div > div.login-form {
                height: 100%;
              }
            `}</style>
          <Grid
            textAlign="center"
            style={{ height: "100%" }}
            verticalAlign="middle"
          >
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as="h2" color="yellow" textAlign="center">
                Forgot password
              </Header>
              <Form size="large" onSubmit={e => this.passReset()}>
                <Segment stacked>
                  <Form.Input
                    required
                    fluid
                    icon="user"
                    iconPosition="left"
                    onChange={(e, email) => this.setState({ email: email.value })}
                    placeholder="E-mail address"
                  />
                  <Button type="submit" color="yellow" fluid size="large">
                    Reset
                  </Button>
                  {loading ? (
                    <Dimmer active inverted>
                      <Loader size="large">Loading</Loader>
                    </Dimmer>
                  ) : null}

                  {errMsg ? <Message>{errMsg}</Message> : errMsg}
                </Segment>
              </Form>
            </Grid.Column>
          </Grid>
        </div>
      )
    }

    return (
      <div className="LoginForm">
        {/*
            Heads up! The styles below are necessary for the correct render of this example.
            You can do same with CSS, the main idea is that all the elements up to the `Grid`
            below must have a height of 100%.
          */}
        <style>{`
            body > div,
            body > div > div,
            body > div > div > div.login-form {
              height: 100%;
            }
          `}</style>
        <Grid
          textAlign="center"
          style={{ height: "100%" }}
          verticalAlign="middle"
        >
          <Grid.Column style={{ maxWidth: 450 }}>
            <Header as="h2" color="yellow" textAlign="center">
              Log-in to your account
            </Header>
            <Form size="large" onSubmit={e => this.login(e)}>
              <Segment stacked>
                <Form.Input
                  required
                  fluid
                  icon="user"
                  iconPosition="left"
                  onChange={(e, email) => this.setState({ email: email.value })}
                  placeholder="E-mail address"
                />
                <Form.Input
                  required
                  fluid
                  icon="lock"
                  iconPosition="left"
                  placeholder="Password"
                  type="password"
                  onChange={(e, password) =>
                    this.setState({ password: password.value })
                  }
                />

                <Button type="submit" color="yellow" fluid size="large">
                  Login
                </Button>
                {loading ? (
                  <Dimmer active inverted>
                    <Loader size="large">Loading</Loader>
                  </Dimmer>
                ) : null}
              </Segment>
            </Form>
            {errMsg ? <Message>{errMsg}</Message> : errMsg}
            <Message>
              New to us? <Link to="/Signup">Sign Up</Link> or go back
              <Link to="/"> home</Link>
              <br />
              <a onClick={()=>this.setState({forgotPass:true})}
                href='#/'>Forgot password</a>
            </Message>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}
export default LoginForm;



// WEBPACK FOOTER //
// ./src/views/LoginAndSignup/LoginForm.js